import React, { useState, useContext, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';

import AppContext from '../context/AppProvider';
import { useNotification } from '../context/NotificationContext';
import { Button, CircularProgress, FormControlLabel, Checkbox } from "@mui/material";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../features/auth/authSlice";
import {useHardEscalateMutation, useEscalateMutation, useGetEscalationMainReasonSubReasonQuery} from "../services/jobsApi";

export default function EscalationModal({ onClose, hardEscalation, jobId, isLoading, setIsLoading}) {

  const { showNotification } = useNotification();

  const [initHardEscalate, {isLoading: hardEscalateIsLoading}] = useHardEscalateMutation();
  const [initEscalate, {isLoading: sendEscalateIsLoading}] = useEscalateMutation();

  let history = useHistory()
  const { currentJob, setCurrentJob } = useContext(AppContext);
  const user = useSelector(selectCurrentUser);

  const escalationReasons = useGetEscalationMainReasonSubReasonQuery();
  console.log("escalation modal, escalationReasons: ", escalationReasons)

  let [mainReason, setMainReason] = useState("");
  let [subReason, setSubReason] = useState("");
  let [details, setDetails] = useState("");

  let [DetailsAlertMessage, setDetailsAlertMessage] = useState("");
  
  // useEffect(() => {
  //   if (escalationReasons) {
  //     setReason(escalationReasons[0]?.id)
  //   }
  // }, [escalationReasons]);

  const reasonOtherId = String(escalationReasons.data?.find((c) => c.name === "Other")?.id);

  const subReasonOtherId = escalationReasons.data?.flatMap((reason) =>
    reason.jobEscalationSubReason?.filter((subReason) =>
      subReason.name === "Other" || subReason.name === "Other error message when attempting to select/cart tickets"
    ).map((subReason) => String(subReason.id))
  ) || [];

  const validationSchema = Yup.object({
    details: Yup.string()
      .when("mainReason", {
        is: (mainReasonId) => String(mainReasonId) === reasonOtherId,
        then: Yup.string().required("Details are required").trim(),
      })
      .when("subReason", {
        is: (subReasonId) => subReasonOtherId.includes(String(subReasonId)),
        then: Yup.string().required("Details are required").trim(),
      }),
  });
  

  function subMainReasonOnChange(subReasonId) {
    setSubReason((prev) => (prev === subReasonId ? "" : subReasonId));
    setDetailsAlertMessage("");
  }
  
  async function localSubmit(e) {
    e.preventDefault();
    
    let jobScalation = {
      "jobId": jobId || currentJob.id,
      "hiveUserId": user.id,
      "issueNote": details,
      "MainReasonId": mainReason,
      "SubReasonId" : subReason
    }
    console.log("jobScalation: ", jobScalation)

    console.log("escalation information: " + jobScalation);

    try {
      await validationSchema.validate({ mainReason, subReason, details }); 
    } catch (error) {
      setDetailsAlertMessage(error.message);
      return;
    }

    try {
      setIsLoading(true)
      
      let res;

      if (hardEscalation) {
        res = await initHardEscalate(jobScalation).unwrap();
      }
      else {
        res = await initEscalate(jobScalation).unwrap();
      }

      console.log("res: " + JSON.stringify(res));
      if (res.status === "OK") {
        if (hardEscalation) {
          window.location.reload();
          return;
        }
        //A: hard escalation, only refresh the same page.
        setCurrentJob(null);
        history.push("/dashboard/jobs");
        //A: bee escalate the job. delete the jobOwnerShip and go to honeycom
      } else {
        showNotification('there is a problem, try again', 'error');
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(JSON.stringify(error));
    }
  }

  function mainReasonOnChange(e) {
    setMainReason(e.target.value);
    setDetailsAlertMessage(""); 
    setSubReason("");
  }  

  function detailsOnChange(e) {
    setDetails(e.target.value)
    setDetailsAlertMessage("");
  }
  return (
    <div className="escalation-modal-contatiner">
      <form onSubmit={localSubmit}>

        <p>Please choose the option that best describes the Issue</p>
        <div style={{ marginBottom: "1em" }} >
          <select value={mainReason} id="escalation-release" name="mainReason" onChange={mainReasonOnChange}>
            <option value="" disabled hidden></option> 
            {escalationReasons.data?.map((escalation) => (<option key={escalation.id} value={escalation.id}>{escalation.name}</option>))}
          </select>
        </div>
      
        {escalationReasons.data?.find((escalationReason) => String(escalationReason.id) === mainReason)?.jobEscalationSubReason?.map((escalation) => (
          <div key={escalation.id}>
            <FormControlLabel
              control={
                <Checkbox
                  value={escalation.id}
                  checked={subReason === escalation.id}
                  onChange={() => subMainReasonOnChange(escalation.id)}
                  sx={{ padding: 0.5 }}
                />
              }
              label={escalation.name}
            />
          </div>
        ))}

        <div className="escalation-text"  style={{ marginTop:"1em" }}>
          <label style={{ font: "var(--p2)" }} >Details:</label>
          <textarea name="details" cols="40" rows="5" onChange={detailsOnChange} ></textarea>
          {DetailsAlertMessage && <p style={{ color: "red", fontSize:"0.75rem", textAlign:"left", fontWeight: 'normal' }}>{DetailsAlertMessage}</p>}
        </div>
        <div className="escalation-buttons" >
          <Button variant="contained" color="secondary" sx={{ width: { xs: '100%', sm:'100%', md: '125px' }, order: { xs: 2, md: 1 } }} onClick={onClose}>Cancel</Button>
          <Button variant="contained" disabled={isLoading  || !mainReason || !subReason} sx={{ margin: { xs: '0 0 0.5em 0', sm:'0.5em 0 0 0', md: '0 0 0 1em' }, width: { xs: '100%', sm:'100%', md: '125px' }, height:"2.5em", order: { xs: 1, md: 2 } }} onClick={localSubmit} >{isLoading?<CircularProgress size="1.5em"/>:"Report Issue"}</Button>
        </div>
      </form>

    </div>
  );
}